import React from 'react';

/**
 * Парсер текста (для фразап ключей)
 * По регулярке находит и заменяет вхождения в тексте на span элементы.
 *
 * @param {string} text - исходный текст
 * @param {any[]} linksProps - коллекция обьектов react props для span элементов вхождений
 * @param {RegExp} regexp - регулярка для нахождения вхождений в тексте
 * @returns {any} - исходный текст | React component
 */
export default function(text = '', linksProps, regexp = /\{link\}(.[^\}]*)\{\/link\}*\}+/gi) {
  const matched = [];
  const arrOther = text
    .replace(regexp, (str, p1) => {
      matched.push(p1);
      return '|||';
    })
    .split('|||');

  if (linksProps.length === matched.length) {
    return arrOther.reduce((sum, item, i) => {
      sum.push(<span key={i}>{item}</span>);
      if (matched[i]) {
        sum.push(<a key={i + '-link'} {...linksProps[i]}>{matched[i]}</a>);
      }
      return sum;
    }, []);
  } else {
    return text;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/linkit.jsx